<template>
  <div class="pl-auto">
    
    <!-- For CPA and CTA -->
    <div v-if="cpaIsDefined || ctaIsDefined" class="d-flex mx-auto justify-content-center">
      <div class="d-flex flex-column my-auto" :class="{'mr-2': !isScoresMerged, 'pb-1': !isScoresMerged}">
        <strong v-if="(textTitle !== undefined)" class="mt-1">{{ textTitle }}</strong>
        <strong v-if="(htmlTitle !== undefined)" class="mt-1" v-html="htmlTitle"></strong>
        <span class="border-top mx-auto cell-content-horizontal-separator" :class="{'d-none': (!cpaIsDefined && !ctaIsDefined)}"></span>
        <small v-if="cpaIsDefined && cpaLabel">{{ cpaLabel }}</small>
        <small v-if="cpaIsDefined && cpaLink" v-html="cpaLink"></small>
        <small v-if="ctaIsDefined && ctaLabel">{{ ctaLabel }}</small>
        <small v-if="ctaIsDefined && ctaLink" v-html="ctaLink"></small>
      </div>
      <ScoredDataComponent v-if="cpaIsDefined && cpaScore && isScoresMerged" :data="$tc('coverage-label', ((cpaCoverage)*100).toFixed(0))" :dataScore="cpaScore" :SmallScoredDataComponent="true" :isTransparentBackground="true" :style="{'width': '6rem'}"></ScoredDataComponent>
      <ScoredDataComponent v-if="ctaIsDefined && ctaScore && isScoresMerged" :data="$tc('coverage-label', ((ctaCoverage)*100).toFixed(0))" :dataScore="ctaScore" :SmallScoredDataComponent="true" :isTransparentBackground="true" :style="{'width': '6rem'}"></ScoredDataComponent>
    </div>

    <!-- For initialText and its CEA -->
    <div v-if="(initialText !== undefined) && (knowledgeProperty === undefined) && displayedAsTextTable" class="d-flex mx-auto justify-content-center">
      {{ initialText }}
    </div>

    <div v-if="(initialText !== undefined) && (knowledgeProperty === undefined) && !displayedAsTextTable" class="d-flex mx-auto justify-content-center">
      <div class="d-flex flex-column my-auto" :class="{'mr-2': !isScoresMerged, 'pb-1': !isScoresMerged}">
        <b :class="{'text-truncate-multiline-5': true}" :title="initialText">{{ initialText }}</b>
        <span class="border-top mx-auto cell-content-horizontal-separator" :class="{'d-none': !ceaIsMerged || !ceaIsDefined}"></span>
        <small v-if="ceaIsMerged && (ceaLabel !== undefined)">{{ ceaLabel }}</small>
        <small v-if="ceaIsMerged && (ceaLink !== undefined)" v-html="ceaLink"></small>
      </div>
      <ScoredDataComponent v-if="ceaIsMerged && ceaIsDefined && (ceaScore !== undefined) && isScoresMerged" :data="''" :dataScore="ceaScore" :SmallScoredDataComponent="true" :isTransparentBackground="true"></ScoredDataComponent>
      <ScoredDataComponent v-if="ceaIsMerged && ceaIsDefined && (ceaScore === undefined) && isScoresMerged" :data="''" :dataScore="0" :SmallScoredDataComponent="true" :isTransparentBackground="true" class="invisible" :class="{'d-none': !ceaIsMerged}"></ScoredDataComponent>
    </div>

    <!-- For knowledgeProperty sample -->
    <div v-if="(initialText === undefined) && (knowledgeProperty !== undefined) && isKnowledgeValueProperty" class="pl-auto">
      <div class="d-flex mx-auto justify-content-center flex-column align-items-center" >
        <div class="d-flex flex-column my-auto pt-3">
          <b>{{ knowledgeProperty.sample }}</b>
        </div>
        <div class="text-right mt-3 flex-fill ml-auto mr-1">
          <small>{{ $tc('pluralized-more-others', knowledgeProperty.length - 1) }}</small>
        </div>
      </div>
    </div>
    <div v-if="(initialText === undefined) && (knowledgeProperty !== undefined) && isKnowledgeUrlProperty" class="pl-auto">
      <div class="d-flex mx-auto justify-content-center flex-column align-items-center" >
        <div class="d-flex flex-column my-auto pt-3">
          <small v-html="knowledgeProperty.sampleLink"></small>
        </div>
        <div class="text-right mt-3 flex-fill ml-auto mr-1">
          <small>{{ $tc('pluralized-more-others', knowledgeProperty.length - 1) }}</small>
        </div>
      </div>
    </div>
    <div v-if="(initialText === undefined) && (knowledgeProperty !== undefined) && isKnowledgeItemProperty" class="pl-auto">
      <div class="mx-2 my-1 px-1 border border-600 d-flex flex-fill justify-content-center flex-column align-items-center bg-whitesmoke " :style="{'position': 'relative'}">
        <div class="d-flex flex-column my-auto pt-1 pb-1">
          <strong class="mt-1">Knowledge CEA</strong>
          <span class="border-top mx-auto mt-0 cell-content-horizontal-separator"></span>
          <small v-if="knowledgeProperty.sampleLabel">{{ knowledgeProperty.sampleLabel }}</small>
          <small v-if="knowledgeProperty.sampleLink" v-html="knowledgeProperty.sampleLink"></small>
        </div>
      </div>
      <div class="text-right mt-1 flex-fill ml-auto mr-1">
          <small>{{ $tc('pluralized-more-others', knowledgeProperty.length - 1) }}</small>
      </div>
    </div>

    <div v-if="!cpaIsDefined && !ctaIsDefined && (initialText === undefined) && (knowledgeProperty === undefined) && !canRequestKnowledgeGraph" class="d-flex mx-auto justify-content-center">
      <div class="d-flex flex-column my-auto pt-3">
        <span href="#" class="my-auto icon icon-modifier-no-access ml-1" title="Add new property column" :style="{'height': 'auto', 'font-size': '1.5rem'}">
        </span>
      </div>
    </div>

    <!-- To find in knowledge -->
    <div v-if="canRequestKnowledgeGraph && !displayedAsTextTable" class="d-flex flex-column align-items-end pt-2">
      <div class="d-flex flex-fill pl-auto mr-1 mt-1 mb-2">
        <span class="icon icon-Network-livebox clickable border rounded shadow mr-0" title="request knowledge graph" :style="{'font-size': '1.4rem', 'padding-bottom': '1px'}" @click="findKnowledgeResult()"></span>
      </div>
      <div class="float-right d-flex flex-column mr-1 rounded bg-white border loadingKnowledgeCeaDiv mt-0" :class="{'isLoading': isWaitingKnowledgeResult}" :style="{'opacity': isWaitingKnowledgeResult ? 1 : 0}">
        <div class="loadingKnowledgeCeaDiv" :class="{'isLoading': isWaitingKnowledgeResult}">
          <div class="mx-2 my-1 px-1 border border-600 d-flex flex-fill justify-content-center bg-whitesmoke" :style="{'position': 'relative'}">
            <div class="spinner-border spinner-border-sm m-1 " role="status">
            </div>
            <strong class="mt-1">Loading... </strong>
          </div>
        </div>
      </div>
      <div v-if="(knowledgeFoundCeas !== undefined)" class="float-right d-flex flex-column mr-1 mt-0 rounded bg-white knowledgeCeaDivContainer" :class="{'border': (knowledgeFoundCeas.length > 0), 'isLoading': isWaitingKnowledgeResult}" :style="{'max-height': (knowledgeFoundCeas.length > 0) ? '999px' : '0px'}">
        <div v-for="(knowledgeFoundCea, knowledgeFoundCeaIndex) in knowledgeFoundCeas" :key="'knowledgeFoundCea--'+knowledgeFoundCeaIndex" class="knowledgeCeaDiv" :class="{'existFavorite': knowledgeFoundCeas.filter(a => a.isFavorite).length > 0, 'isFavorite': isFavoriteKnowledgeFoundCea(knowledgeFoundCea), 'isLoading': isWaitingKnowledgeResult}">
          <div class="mx-2 my-1 px-1 border border-600 d-flex flex-fill justify-content-center bg-whitesmoke " :style="{'position': 'relative'}">
            <div class="d-flex flex-column my-auto pt-1 pb-1">
              <strong v-if="knowledgeFoundCea.isItemProperty" title="Knowledge CEA" class="mt-1 mr-1"><span class="mr-0 pb-1 icon icon-Network-livebox small"></span>CEA</strong>
              <strong v-if="knowledgeFoundCea.isUrlProperty" title="Knowledge Link" class="mt-1 mr-1"><span class="mr-0 pb-1 icon icon-Network-livebox small"></span>Link</strong>
              <strong v-if="knowledgeFoundCea.isValueProperty" title="Knowledge Value" class="mt-1 mr-1"><span class="mr-0 pb-1 icon icon-Network-livebox small"></span>Value</strong>
              <strong v-if="knowledgeFoundCea.isMediaProperty" title="Knowledge Media" class="mt-1 mr-1"><span class="mr-0 pb-1 icon icon-Network-livebox small"></span>Media</strong>
              <span class="border-top mx-auto mt-0 cell-content-horizontal-separator"></span>
              <small v-if="knowledgeFoundCea.label && !knowledgeFoundCea.isUrlProperty && !knowledgeFoundCea.isMediaProperty" :style="{'color': knowledgeGraphResultsColorUsed}">{{ knowledgeFoundCea.label }}</small>
              <small v-if="knowledgeFoundCea.link && !knowledgeFoundCea.isValueProperty" :style="{'color': knowledgeGraphResultsColorUsed}" class="inheritColor" v-html="knowledgeFoundCea.link"></small>
            </div>
            <div class="d-flex flex-row mt-3 ml-1">
              <span v-for="(matchingCpa, cpaIndex) in knowledgeFoundCea.matchingCpas" :key="'knowledgeFoundCea-MatchingCpa'+cpaIndex" :title="matchingCpa.cpa.label" class="mt-0 mr-1 icon icon-Link clickable" @click="selectKnowledgeCpa(matchingCpa.cpa)" @mouseover="onMouseOverKnowledgeCpa(matchingCpa.cpa.headIndex, matchingCpa.cpa.tailIndex)" @mouseleave="onMouseLeaveKnowledgeCpa(matchingCpa.cpa.headIndex, matchingCpa.cpa.tailIndex)">
              </span>
            </div>
            <span v-if="!knowledgeFoundCea.isFavorite" class="icon icon-Modifier-favorite clickable my-0 mr-0" title="select as favorite" :style="{'position': 'absolute', 'right': '1px'}" @click="selectKnowledgeCeaAsFavorite(knowledgeFoundCea)"></span>
            <span v-if="knowledgeFoundCea.isFavorite" class="icon icon-Medal clickable my-0 mr-0" title="unselect favorite" :style="{'position': 'absolute', 'right': '1px'}" @click="unselectKnowledgeCeaAsFavorite(knowledgeFoundCea)"></span>
          </div>
        </div>
      </div>
      <div v-if="isEmptyKnowledgeResult" class="float-right d-flex flex-column mr-1 mt-0 rounded bg-white knowledgeCeaDivContainer" :class="{'border': (!isWaitingKnowledgeResult), 'isLoading': isWaitingKnowledgeResult}" :style="{'max-height': (!isWaitingKnowledgeResult) ? '999px' : '0px'}">
        <div class="knowledgeCeaDiv">
          <div class="mx-2 my-1 px-1 border border-600 d-flex flex-fill justify-content-center bg-whitesmoke " :style="{'position': 'relative'}">
            <div class="d-flex flex-column my-auto pt-1 pb-1">
              <span href="#" class="my-auto icon icon-modifier-no-access mx-3" title="No result found" :style="{'height': 'auto', 'font-size': '1.2rem'}">
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="canRequestKnowledgeGraph && displayedAsTextTable" class="d-flex mx-auto justify-content-center">
      <div v-if="(knowledgeFoundCeas !== undefined)" class="">
        <div v-for="(knowledgeFoundCea, knowledgeFoundCeaIndex) in knowledgeFoundCeas.filter(knowledgeFoundCea => knowledgeFoundCea.isFavorite)" :key="'knowledgeFoundCea--'+knowledgeFoundCeaIndex">
          <div :style="{'position': 'relative'}">
            <small v-if="knowledgeFoundCea.label" :style="{'color': knowledgeGraphResultsColorUsed}">{{ knowledgeFoundCea.label }}</small>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import ScoredDataComponent from './ScoredDataComponent';

export default {
  name: "CellContentDisplayer",
  components: {
    ScoredDataComponent,
  },
  props: [
    "initialRowIndex",
    "initialText",
    "htmlTitle", "textTitle",
    "ceaIsMerged", "ceaIsDefined", "ceaLabel", "ceaLink", "ceaScore",
    "isScoresMerged",
    "isKnowledgeValueProperty", "isKnowledgeUrlProperty", "isKnowledgeItemProperty", "knowledgeProperty",
    "canRequestKnowledgeGraph", "knowledgeFoundCeas", "isWaitingKnowledgeResult",
    "cpaIsDefined", "cpaLabel", "cpaLink", "cpaScore", "cpaCoverage",
    "ctaIsDefined", "ctaLabel", "ctaLink", "ctaScore", "ctaCoverage",
    "knowledgeGraphResultsColor",
    "displayedAsTextTable"
  ],
  data() {
    return {
      cpaLinkHeightInPx: 17,
      cpaLinkWidthInPx: 20,
    }
  },
  mounted() {
  },
  updated() {
  },
  computed: {
    cpaLinkHeight: function() {
      return this.cpaLinkHeightInPx + 'px';
    },
    cpaLinkWidth: function() {
      return this.cpaLinkWidthInPx + 'px';
    },
    knowledgeGraphResultsColorUsed: function() {
      if (this.knowledgeGraphResultsColor) {
        return this.knowledgeGraphResultsColor;
      }
      return '#FF6600';
    },
    isEmptyKnowledgeResult: function() {
      return (this.knowledgeFoundCeas) && (this.knowledgeFoundCeas.length === 0);
    }
  },
  methods: {
    findKnowledgeResult: function () {
      this.$emit('find-knowledge-result', {});
    },
    isFavoriteKnowledgeFoundCea: function(knowledgeFoundCea) {
      const favoriteKnowledgeFoundCea = this.knowledgeFoundCeas.filter(foundCeaToFilter => (foundCeaToFilter.isFavorite === true))
      if ((favoriteKnowledgeFoundCea !== undefined) && (favoriteKnowledgeFoundCea.length === 1)) {
        // check if knowledgeFoundCea is the favorite one
        return ((knowledgeFoundCea.label === favoriteKnowledgeFoundCea[0].label) && (knowledgeFoundCea.uri === favoriteKnowledgeFoundCea[0].uri));
      } else {
        return false;
      }
    },
    selectKnowledgeCpa: function(cpa) {
      this.$emit('select-knowledge-cpa', {cpa});
    },
    onMouseOverKnowledgeCpa: function(headIndex, tailIndex) {
      this.$emit('on-mouse-over-knowledge-cpa', {headIndex, tailIndex});
    },
    onMouseLeaveKnowledgeCpa: function(headIndex, tailIndex) {
      this.$emit('on-mouse-leave-knowledge-cpa', {headIndex, tailIndex});
    },
    // onDoubleClickKnowledgeCpa: function(headIndex, tailIndex) {
    //  this.$emit('on-double-click-knowledge-cpa', {headIndex, tailIndex});
    // },
    selectKnowledgeCeaAsFavorite: function(knowledgeFoundCea) {
      this.$emit('select-knowledge-result-as-favorite', {knowledgeFoundCea});
    },
    unselectKnowledgeCeaAsFavorite: function(knowledgeFoundCea) {
      this.$emit('unselect-knowledge-result-as-favorite', {knowledgeFoundCea});
    },
  }
};
</script>
<style scoped>
.cell-content-horizontal-separator {
  height: 5px;
  width: 80px;
}

.icon.icon-Network-livebox.clickable {
  background-color: whitesmoke;
}

.bg-whitesmoke {
  background-color: whitesmoke;
}

.knowledgeCeaDiv {
  max-height: 150px;
  transition: max-height 0.75s ease-in-out;
  overflow: hidden;
}

.knowledgeCeaDiv:hover {
  transition: max-height 0.75s ease-in-out;
  overflow: inherit;
}

.knowledgeCeaDiv.existFavorite:not(.isFavorite), .knowledgeCeaDiv.isLoading {
  max-height: 0px;
  overflow: hidden;
}

.knowledgeCeaDivContainer:not(.isLoading) {
  max-height: 999px;
  opacity: 1;
  transition: max-height 2s ease-in-out 1s, opacity 1s ease-in-out 1s, border 0.15s ease-in-out 1s;
}

.knowledgeCeaDivContainer.isLoading {
  max-height: 0px;
  opacity: 0;
}

.loadingKnowledgeCeaDiv {
  max-height: 999px;
  transition: max-height 0.75s ease-in-out, opacity 0.75s ease-in-out 0.15s;
  overflow: clip;
  /* overflow: hidden; */
}

.loadingKnowledgeCeaDiv:not(.isLoading) {
  max-height: 0px;
  /* overflow: clip; */
  overflow: hidden;
}

/deep/ .inheritColor a {
  color: inherit;
}

</style>